module.exports = __webpack_public_path__ + "static/media/k-K vector.4a67a427.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/k-K vector.png
// module id = 165
// module chunks = 0